<template>
    <v-footer class="font-weight-medium kings__footer" padless="true">
        <v-container fluid>
            <v-row>
                <v-col cols="12" md="6">
                    <v-card dark flat>
                        <v-card-title>
                            <v-icon left>mdi-account-box</v-icon> Contact Us
                        </v-card-title>
                        <v-card-subtitle class="pt-5 pb-0">
                            <v-icon left>mdi-map-marker</v-icon>Address
                        </v-card-subtitle>
                        <v-card-text class="pl-12">
                            King's University College<br>
                            at Western University Canada<br>
                            266 Epworth Avenue<br>
                            London Ontario, Canada N6A 2M3
                        </v-card-text>
                        <v-card-subtitle class="pb-0">
                            <v-icon left>mdi-phone</v-icon>Telephone
                        </v-card-subtitle>
                        <v-card-text class="pl-12">
                            519-433-3491 / Toll Free: 1-800-265-4406
                        </v-card-text>
                        <v-card-subtitle class="pb-0">
                            <v-icon left>mdi-email</v-icon>E-mail
                        </v-card-subtitle>
                        <v-card-text class="pl-12">
                            <a href="mailto:info@kings.uwo.ca">info@kings.uwo.ca</a>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card dark flat>
                        <v-card-title>
                            <v-icon left>mdi-share</v-icon> Follow Us
                        </v-card-title>
                        <v-card-text>
                            <v-btn class="mx-2" href="https://www.facebook.com/kingsatwestern" fab dark small
                                color="#3b5998" target="_blank">
                                <v-icon dark>
                                    mdi-facebook
                                </v-icon>
                            </v-btn>
                            <v-btn class="mx-2" href="https://twitter.com/kingsatwestern" fab dark small color="#00acee"
                                target="_blank">
                                <v-icon dark>
                                    mdi-twitter
                                </v-icon>
                            </v-btn>
                            <v-btn class="mx-2" href="https://www.instagram.com/kingsatwestern/" fab dark small
                                color="#F77737" target="_blank">
                                <v-icon dark>
                                    mdi-instagram
                                </v-icon>
                            </v-btn>
                            <v-btn class="mx-2" href="https://www.youtube.com/user/kingsatuwo" fab dark small
                                color="#FF0000" target="_blank">
                                <v-icon dark>
                                    mdi-youtube
                                </v-icon>
                            </v-btn>
                            <v-btn class="mx-2" href="https://www.tiktok.com/@kingsatwestern" fab dark small
                                color="#69C9D0" target="_blank">
                                <v-icon dark>
                                    mdi-music-note
                                </v-icon>
                            </v-btn>
                            <v-btn class="mx-2" href="https://www.linkedin.com/school/kingsatwestern/" fab dark small
                                color="#0e76a8" target="_blank">
                                <v-icon dark>
                                    mdi-linkedin
                                </v-icon>
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
export default {
    name: 'parent-approval-footer'
}
</script>

<style scoped>
.kings__footer {
    background: #004236;
    border-top: 4px solid #333;
}

.v-card {
    background: transparent;
}

.v-card-title,
a {
    color: #d7ae28;
}
</style>